
import { io } from "socket.io-client";
import { getSocketUrl } from "./config/env";


const socket = io(
  getSocketUrl(),
  { withCredentials: true }
);

socket.on("connect", () => {
});




export default socket
